module.exports = __webpack_public_path__ + "img/材料力学5_3.b7f4d6c3.jpg";